import styles from "./ThemedButton.module.css";

import ConversionModal from "@/components/premium/ConversionModal/ConversionModal";
import { useModalContext } from "@/context/ModalContext";

interface ThemedButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
}

export default function ThemedButton({ title, ...props }: ThemedButtonProps) {
  return (
    <button className={styles.btn} {...props}>
      {title}
    </button>
  );
}

interface ThemedButtonPropsPlus
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export function DimensionalPlusThemedButton({
  ...props
}: ThemedButtonPropsPlus) {
  const { setModalComponent } = useModalContext();

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        setModalComponent(<ConversionModal />);
      }}
      className={styles.btn}
      {...props}
    >
      Unlock with Dimensional <span className={styles.plusText}>Plus</span>
    </button>
  );
}
